import { render, staticRenderFns } from "./CarInfoForm.vue?vue&type=template&id=64dc4752&scoped=true&"
import script from "./CarInfoForm.vue?vue&type=script&lang=js&"
export * from "./CarInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./CarInfoForm.vue?vue&type=style&index=0&id=64dc4752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc4752",
  null
  
)

export default component.exports